// extracted by mini-css-extract-plugin
module.exports = {"text":"DataNotification_text__1g0fB","AlertIcon":"DataNotification_AlertIcon__3Vace"};